<template>
    <a
        href="javascript:void(0)"
        @click="copy"
        class="single-product__body-top__icon"
        data-bs-toggle="tooltip" :title="copied ? 'کپی شد!' : 'کپی کردن لینک محصول'"
    >
        <i class="fa fa-copy"></i>
    </a>
    <span style="width: 0; height: 0; overflow: hidden; position:relative; display: inline-block">
        <textarea ref="input" :value="productUrl" style="position:absolute; top: -10000px; left: -10000px;" />
    </span>
</template>

<script>
import {ProductMixin} from "./ProductMixin";

export default {
    mixins: [ProductMixin],
    name: "CopyProductUrlButton",
    data() {
        return {
            copied: false
        }
    },
    methods: {
        copy() {
            this.copied = true;
            const element = this.$refs.input;
            element.select();
            element.setSelectionRange(0, 99999);
            document.execCommand('copy');
            setTimeout(() => {
                this.copied = false
            }, 300);
        }
    }
}
</script>
